import React, { useState } from "react";
import {CancelButton,SubmitButton,} from "../../../../../../Components/Utils/Buttons";
import { useFormik } from "formik";
import {FormikSelectTwoSmall,} from "../../../../../../Components/Utils/Select";
import { NuDateSmall } from "../../../../../../Components/Utils/Input";
import UseDropDown from "../../../../../../Components/Hooks/useDropDown";
import NewReportTable from "../../../../../../Components/Others/NewReportTable";
import UseFetchReportData from "../../../../../../Components/Hooks/useFetchReportData";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import {
  DownloadPDF,
  DownloadXLXS,
} from "../../../../../../Components/Utils/Download";

function SurveyReport() {
  const [showFilter, setShowFilter] = useState(false);
  // const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const [filter, setFilter] = useState(false);

  const { data: user } = UseDropDown(`/user/new-drop-down`);

  const headers = [
    {
      title: "Ref.",
      width: "10%",
      field: "Ref",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Client",
      width: "15%",
      field: "Client",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Project",
      width: "15%",
      field: "Project",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Location",
      width: "15%",
      field: "Location",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Inspection Date",
      width: "15%",
      field: "InspectionDate",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },
    {
      title: "Status",
      width: "15%",
      field: "Status",
      textAlign: "left",
      rowAlign: "left",
    },
  ];

  const [filterProps, setFilterProps] = useState({
    status: "",
    assigneeId: "",
    dateFrom: "",
    dateTo: "",
  });

  const [params, setParams] = useState({
    status: "",
    assigneeId: "",
    dateFrom: "",
    dateTo: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value) => {
        await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting
      setParams({
        status: value.status,
        assigneeId: value.assigneeId || [],
        dateFrom: value.dateFrom,
        dateTo: value.dateTo,
      });
      setTimeout(() => {
        setFilter(true);
        // closeFilterDialog();
      }, 1000);
    },
  });
  const { data, getData, dataLoading, total, other } = UseFetchReportData(
    "/xlsx-report/filter-survey-reports",
    params
  );

  function closeFilterDialog() {
    setShowFilter(false);
    formik.resetForm();
    setFilter(false);
    setParams({
      status: "",
      assigneeId: "",
      dateFrom: "",
      dateTo: "",
    });
  }

  const { value: status, getData: refStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Survey"
  );
  return (
    <>
      <div className="w-full h-full overflow-auto">
        
          <div className="flex gap-x-2 justify-between  w-full  py-2">
            <div className=" max-w-[250px] pr-7 ">
              <p className=" font-semibold text-xs 2xl:text-sm  ">
                Survey Report : {data?.length}
              </p>
            </div>
            <div className=" flex-1 ">
              <form onSubmit={formik.handleSubmit}>
                <div className=" w-full grid grid-cols-4 2xl:grid-cols-5 gap-3">
                  <NuDateSmall
                    label="From "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="dateFrom"
                    width="w-full"
                  />

                  <NuDateSmall
                    label="To "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="dateTo"
                    width="w-full"
                  />

                  <FormikSelectTwoSmall
                    label="Assignee"
                    Options={user}
                    formik={formik}
                    placeholder="Choose"
                    name="assigneeId"
                    width="w-full"
                    FixPosition={true}
                    PortalTarget={false}
                  />

                  <FormikSelectTwoSmall
                    type="text"
                    label="Status"
                    placeholder="Status"
                    Options={status}
                    formik={formik}
                    name="status"
                    width="w-full"
                    displayProperty={"Status"}
                    propertyName={"Status_Survey"}
                    getFunc={refStatus}
                  />
                                  <div className=" w-full flex justify-end ">
                  <div className=" w-full flex items-end gap-2">
                    <SubmitButton name="Apply" isLoading={formik.isSubmitting} />
                    <CancelButton
                      label="Clear"
                      handleClick={closeFilterDialog}
                    />
                  </div>
                </div>
                </div>

              </form>
            </div>
            <div className=" w-[80px] flex justify-end items-end gap-4 ">
              <DownloadPDF
                url={`/xlsx-report/export-survey-report-pdf`}
                fileName="Survey Report"
                params={params}
              />
              <DownloadXLXS
                url={`/xlsx-report/export-survey-report-xlsx`}
                fileName="Survey Report"
                params={params}
              />
            </div>
          </div>
        
        <NewReportTable
          headers={headers}
          data={data}
          dataLoading={dataLoading}
        />
      </div>
    </>
  );
}

export default SurveyReport;
